"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _bootstrap = require("./bootstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _informed = require("informed");
var _immutableSetter = require("immutable-setter");
var _excluded = ["field", "children", "footerTemplate", "initialValues", "formApi", "initial_count"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FIELD_MAPPINGS = {
  string: _bootstrap.BootstrapText,
  choice: _bootstrap.BootstrapChoiceSelect
};
var FormSetWrapper = /*#__PURE__*/function (_Component) {
  function FormSetWrapper(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FormSetWrapper);
    _this = _callSuper(this, FormSetWrapper, [props]);
    var initialCount = Array.from({
      length: _this.props.initialCount
    }, function (index) {
      return _this.deleteForm.bind(_this, index);
    });
    _this.state = {
      formStates: _this.props.initialValues ? _this.props.initialValues.map(function (row, index) {
        return _this.deleteForm.bind(_this, index);
      }) : initialCount
    };
    return _this;
  }
  (0, _inherits2["default"])(FormSetWrapper, _Component);
  return (0, _createClass2["default"])(FormSetWrapper, [{
    key: "deleteForm",
    value: function deleteForm(index) {
      this.setState({
        formStates: (0, _immutableSetter.setIn)(this.state.formStates, [index], undefined)
      });
    }
  }, {
    key: "addForm",
    value: function addForm() {
      this.setState({
        formStates: this.state.formStates.concat([this.deleteForm.bind(this, this.state.formStates.length)])
      });
    }
  }, {
    key: "renderFormSet",
    value: function renderFormSet() {
      var _this$props = this.props,
        field = _this$props.field,
        children = _this$props.children,
        footerTemplate = _this$props.footerTemplate,
        initialValues = _this$props.initialValues,
        formApi = _this$props.formApi,
        initial_count = _this$props.initial_count,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("div", rest, this.state.formStates.map(function (delete_function, index) {
        return delete_function && /*#__PURE__*/_react["default"].createElement(_informed.Scope, {
          scope: field + "[".concat(index, "]"),
          key: "scope-".concat(index)
        }, children(index, delete_function, initialValues));
      }), footerTemplate && footerTemplate(this.addForm.bind(this)));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderFormSet();
    }
  }]);
}(_react.Component);
FormSetWrapper.propTypes = {
  children: _propTypes["default"].func.isRequired,
  footerTemplate: _propTypes["default"].func,
  initialCount: 0
};
var FormSet = (0, _informed.withFormApi)(FormSetWrapper);
var _default = exports["default"] = FormSet;